$(document).ready(function(){
  // $('body').on('click','.custom-mobile-link', function(e){
  //   if ($(window).width() > 797) {
  //     $(this).closest('label').click();  
  //   } else {
  //     e.preventDefault();
  //     $(this).next(".close-dropdown").trigger("click");
  //   }
  // });

  // $('.thumbnail-add-to-cart__caption .product-thumbnail').matchHeight();
  
  if ( $('.custom-landing-page-image-grid-section .wulf-overlap-title').length ) {
    $('.custom-landing-page-image-grid-section .wulf-overlap-title').matchHeight();
  }

  var featuredReviewsSlider = $('#featuredReviewsWrapper');

  $(featuredReviewsSlider).flickity({
    lazyLoad: 2,
    freeScroll: true,
    imagesLoaded: true,
    draggable: true,
    autoPlay: true,
    cellAlign: 'center',
    wrapAround: true,
    pageDots: true,
    contain: true,
    prevNextButtons: true,
    initialIndex: 0,
    on: {
      ready: function ready() {
        // Reset layout to avoid collapsing issues
        setTimeout(function () {
          $(featuredCollectionSlider).flickity('resize');
        }, 500);
      }
    }
  });

  if ( $('#customFieldChefs').length ) {
    $('#customFieldChefs').flickity({
      wrapAround: true,
      imagesLoaded: false,
      initialIndex: 1,
      autoPlay: true,
      pauseAutoPlayOnHover: false,
      pageDots: false,
      on: {
        ready: function ready() {
          // Reset layout to avoid collapsing issues
          setTimeout(function () {
            $(customFieldChefs).flickity('resize');
            $(customFieldChefs).fadeIn().css('opacity','1');
          }, 600);
        }
      }
    });
    $('#chefTestimonialPrev').on('click',function(){
      $('#customFieldChefs').flickity( 'previous' )
    });
    $('#chefTestimonialNext').on('click',function(){
      $('#customFieldChefs').flickity( 'next' )
    });
  }

  if ( $('#articleImageGallery').length ) {
    $('#articleImageGallery').flickity({
      wrapAround: true,
      imagesLoaded: true,
      on: {
        ready: function ready() {
          // Reset layout to avoid collapsing issues
          setTimeout(function () {
            $(articleImageGallery).flickity('resize');
            $(articleImageGallery).fadeIn().css('opacity','1');
          }, 500);
        }
      }
    });
  }



  $("#articlesWrapperx .featured-article")
    .sort(sort_li) // sort elements
    .appendTo('#articlesWrapper'); // append again to the list

  $("#articlesWrapper")
    .css('opacity',1);
  
  // sort function callback
  function sort_li(a, b){
    // console.log(($(b).data('updated')) < ($(a).data('updated')) ? -1 : 1);
      return ($(b).data('updated')) < ($(a).data('updated')) ? -1 : 1;    
  }

  atcFormIsInView();

  var $cartAccordionHeading = $('#cartShippingMotivator .faq-accordion > dt > button');

  // console.log($cartAccordionHeading);
  $('#cartShippingMotivator .faq-accordion > dd').attr('aria-hidden', true);
  $cartAccordionHeading.attr('aria-expanded', false);
  $cartAccordionHeading.on('click activate', function () {
    // console.log('accordion click cart');
    var faqTitle = $(this);
    var faqIcons = $(this).find('.icon');
    var state = $(this).attr('aria-expanded') === 'false' ? true : false;
    $(this).attr('aria-expanded', state);
    $(this).parent().next().slideToggle(function () {
      if (faqIcons.hasClass('icon--active')) {
        faqIcons.toggleClass('icon--active');
      }
    });
    $(this).parent().next().attr('aria-hidden', !state);
    if ( $('#panel-articles').length ) {
      var minTitleHeight = 0;
      var minImageHeight = 0;
      $('#panel-articles .image-element__wrap').each(function(){
        // console.log($(this).height());
        if ( $(this).height() > minImageHeight ) {
          minImageHeight = $(this).height();
        }
      });
      $('#panel-articles .image-element__wrap').each(function(){
        $(this).height(minImageHeight);
      });
      // console.log({minImageHeight});

    }
    return false;
  });

  // $('body').on('click','.cart-accordion__button',function(){
  //   // console.log('real cart accordion click');
  //   var faqIcons = $(this).find('.icon');
  //   var state = $(this).attr('aria-expanded') === 'false' ? true : false;
  //   $(this).attr('aria-expanded', state);
  //   $(this).parent().next().slideToggle(function () {
  //     if (faqIcons.hasClass('icon--active')) {
  //       faqIcons.toggleClass('icon--active');
  //     }
  //   });
  //   $(this).parent().next().attr('aria-hidden', !state);
  //   return false;
  // });

  // cart champion popup
  $("#cart_form #checkout").on("click", function(e) {
    var champion_popup = $(".cart-champion-popup");
    if (champion_popup.length > 0 && champion_popup.hasClass("popup-hide")) {
      e.preventDefault();
      champion_popup.removeClass("popup-hide");
      champion_popup.attr("data-flag", "cartPage");
    }
  })

  $('[data-ajax-cart-drawer]').on("click", ".button--add-to-cart", function(e) {
    var champion_popup = $(".cart-champion-popup");
    if (champion_popup.length > 0 && champion_popup.hasClass("popup-hide")) {
      e.preventDefault();
      champion_popup.removeClass("popup-hide");
      champion_popup.attr("data-flag", "drawer");
    }
  })
  $(".shopify-payment-button").on("click", function(e) {
    var champion_popup = $(".cart-champion-popup");
    if (champion_popup.length > 0 && champion_popup.hasClass("popup-hide")) {
      e.preventDefault();
      e.stopPropagation();
      champion_popup.removeClass("popup-hide");
      champion_popup.attr("data-flag", "BuyNow");
    }
  })

  $(".cart-champion-popup .fc-item").on("click", function() {
    var notes = $(this).data("note");

    if ($(".cart-champion-popup").attr("data-flag") == "drawer") {
      var origin_notes = $('.ajax-cart__form textarea[name="note"]').text();
      var index = origin_notes.indexOf("Superbowl");
      // console.log(index);
      if (index > 0) {
        origin_notes = origin_notes.substr(0, index);  
      } else {
        origin_notes = '';
      }
      // console.log(origin_notes);
      var final_notes = origin_notes + " " + notes;
      $('.ajax-cart__form textarea[name="note"]').text(final_notes);
      $(".ajax-cart__form .button--add-to-cart").trigger("click");
    } else if ($(".cart-champion-popup").attr("data-flag") == "BuyNow") {
      var updateData = {
        'note': notes
      };
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updateData)
      })
      .then(response => {
        $(".shopify-payment-button").trigger("click");
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    } else {
      var origin_notes = $('#cart_form .cart__notes textarea[name="note"]').text();
      var index = origin_notes.indexOf("Superbowl");
      if (index > 0) {
        origin_notes = origin_notes.substr(0, index);  
      }  else {
        origin_notes = '';
      }
      var final_notes = origin_notes + " " + notes;
      $('#cart_form .cart__notes textarea[name="note"]').text(final_notes);
      $("#cart_form #checkout").trigger("click");
    }
  })
  
  $('.featured-list-slider-nav').on('init', function(event, slick){
    $slideNodes = $(this).find('.thumbnail-image');
    $slideNodes.each(function(){
      $(this).addClass('found-thumb-wulf');
      $(this).contents().filter(function() {
        // get only the text nodes
        return this.nodeType === 3;
      })
      .remove();
    });
    $(this).addClass('wulf-init');
  });
  
  function initFeaturedSlides() {
    $('.featured-list-slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: true,
      asNavFor: '.featured-list-slider-nav'
    });
    $('.featured-list-slider-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      vertical:true,
      infinite: true,
      asNavFor: '.featured-list-slider-for',
      dots: false,
      focusOnSelect: true,
      verticalSwiping:true,
      responsive: [
        {
          breakpoint: 580,
          settings: {
            vertical: false,
          }
        }
      ]
    });
  }

  function destroyFeaturedSlides() {
    $('.featured-list-slider-for').slick('unslick');
    $('.featured-list-slider-nav').slick('unslick');
  }

  initFeaturedSlides();
  
  $('body').on('click', '.wholesale-featured-slide', function() {
    var dataNum = $(this).data('num');
    $('.wholesale-featured-list').removeClass('active');
    //$('.wholesale-featured-list[data-num="' + dataNum + '"]').addClass('active');
    
    var $newActiveSlide = $('.wholesale-featured-list[data-num="' + dataNum + '"]');
    // console.log($newActiveSlide);
    $newActiveSlide.addClass('active');
    
    
    $([document.documentElement, document.body]).animate({
        scrollTop: $newActiveSlide.offset().top + (-100)
    }, 1000);
    
    
    destroyFeaturedSlides();
    initFeaturedSlides()
    
  });
});

$(window).on('scroll', function () {
  atcFormIsInView();
});

function atcFormIsInView() {
  var $buttons = $('.purchase-details__buttons');
  var $details = $('.purchase-details.desktop-hide');
  
  if ($buttons.length && $details.length) {
    var top = $(window).scrollTop(),
        bottom = $(window).scrollTop() + $(window).height(),
        divTop = $details.offset().top - 30,
        divHeight = $buttons.outerHeight(),
        divBottom = divTop + divHeight + 30;

    if (divBottom > top && divTop < bottom) {
      $('body').removeClass('add-to-cart-out-of-view');
    } else {
      $('body').addClass('add-to-cart-out-of-view');
    }
  }
}

// $('body').on('focusout ', '#giftMessage', function() {
//   // console.log('change');
//   // console.log($(this));
//   var dynamicGiftMessage = $(this).val();
//   // console.log(dynamicGiftMessage);
  
//   var attributeString = `attributes[gift_message]=${dynamicGiftMessage}`;
//   // console.log(attributeString);
//   $.post('/cart/update.js', attributeString);
// });

// $('body').on('focusout ', '#note', function() {
//   // console.log('change');
//   // console.log($(this));
//   var dynamicNote = $(this).val();
//   // console.log(dynamicNote);
  
//   //var attributeString = `attributes[gift_message]=${dynamicGiftMessage}`;
//   //// console.log(attributeString);
//   $.post('/cart/update.js', {note: dynamicNote});
// });

// document.addEventListener('DOMContentLoaded', function() {
//   // Flag to track if the modal class was added
//   let modalClassAdded = false;

//   // Create a MutationObserver to watch for changes to the body element's class attribute
//   const observer = new MutationObserver(function(mutations) {
//     mutations.forEach(function(mutation) {
//       if (mutation.attributeName === 'class') {
//         const bodyClassList = document.body.classList;
//         // Check if the modal class is added
//         if (bodyClassList.contains('rebuy-modal-visible')) {
//           modalClassAdded = true;
//         }
//         // Check if the modal class was added and is now removed, and if the collection class is still present
//         if (modalClassAdded && !bodyClassList.contains('rebuy-modal-visible') && bodyClassList.contains('collection')) {
//           //observer.disconnect();
//           // console.log("this is a collection page rebuy cart closure");
//           // use the new cart data to update the page
//           async function updateCartQtys() {
//             try {
//               // Fetch cart data
//               const response = await fetch('/cart.js');
//               const cart = await response.json();
          
//               // Extract [product title, variant ID, quantity]
//               const cartData = cart.items.map(item => [item.product_title, item.product_id, item.variant_id, item.quantity]);
          
//               // console.log(cart); // Log cart data for debugging
//               // console.log(cartData); // Log cart data for debugging
          
//               // Update cart count
//               document.querySelectorAll('.header-cart__count[data-bind="itemCount"]').forEach(cartCountElement => {
//                 cartCountElement.textContent = cart.item_count;
//                 // console.log(`Updated cart count to ${cart.item_count}`);
//               });
            
//               // Loop through cart items
//               cartData.forEach(([title, productId, variantId, quantity]) => {
//                 // Select all matching option elements by variant ID
//                 const options = document.querySelectorAll(`option.annotated-option[value="${variantId}"]`);
                
//                 if (options.length > 0) {
//                   options.forEach(option => {
//                     option.setAttribute('data-cart-qty', quantity);
//                     // console.log(`Updated variant ${variantId} to cart quantity ${quantity}`);
//                   });
//                 } else {
//                   // console.log(`No matching option found for variant ID: ${variantId}`);
//                 }

//                 const purchaseDetails = document.querySelectorAll(`.purchase-details__quantity[data-cart-item-variant-id="${variantId}"]`);

//                 if (purchaseDetails.length > 0) {
//                   purchaseDetails.forEach(detail => {
//                     const inputField = detail.querySelector('.quantity-input');
//                     if (inputField) {
//                       inputField.value = quantity;
//                       // console.log(`Updated input for variant ${variantId} to cart quantity ${quantity}`);
//                     }
//                   });
//                 } else {
//                   // console.log(`No matching purchase-details__quantity found for variant ID: ${variantId}`);
//                 }
//               });

//               /// now make sure any item removed from cart reverts back to the ATC button instead of the qty controls
//               // Get all elements with data-purchase-details-product-id and data-purchase-details-quantity-product-id
//               const purchaseDetailElements = document.querySelectorAll('[data-purchase-details-product-id]');
//               purchaseDetailElements.forEach(element => {
//                 const productId = element.getAttribute('data-purchase-details-product-id');
//                 // Check if the product ID exists in the cart
//                 const inCart = cartData.some(([, cartProductId]) => cartProductId == productId);
//                 // Add or remove the 'qty-in-cart' class
//                 if (inCart) {
//                   element.classList.add('item-in-cart-purchase-details');
//                   //// console.log(`Added class item-in-cart-purchase-details to product ${productId}`);
//                 } else {
//                   element.classList.remove('item-in-cart-purchase-details');
//                   //// console.log(`Removed class item-in-cart-purchase-details from product ${productId}`);
//                 }
//               });

//               const purchaseDetailQtyElements = document.querySelectorAll('[data-purchase-details-quantity-product-id]');
//               purchaseDetailQtyElements.forEach(element => {
//                 const productId = element.getAttribute('data-purchase-details-quantity-product-id');
//                 // Check if the product ID exists in the cart
//                 const inCart = cartData.some(([, cartProductId]) => cartProductId == productId);
//                 // Add or remove the 'qty-in-cart' class
//                 if (inCart) {
//                   element.classList.add('item-in-cart-show-qty');
//                   //// console.log(`Added class item-in-cart-show-qty to product ${productId}`);
//                 } else {
//                   element.classList.remove('item-in-cart-show-qty');
//                   //// console.log(`Removed class item-in-cart-show-qty from product ${productId}`);
//                 }
//               });

//             } catch (error) {
//               console.error('Error fetching or updating cart data:', error);
//             }
//           }
          
//           // Call the function
//           updateCartQtys();
//           // end use the new cart data to update the page
//           // Once the modal is closed, we no longer need to observe changes
//           //window.location.reload();
//         } else if (modalClassAdded && !bodyClassList.contains('rebuy-modal-visible') && bodyClassList.contains('index')) {
//           observer.disconnect();
//           // console.log("this is an index page rebuy cart closure");
//           // Once the modal is closed, we no longer need to observe changes
//           //window.location.reload();
//         }
//       }
//     });
//   });

//   // Start observing the body element for attribute changes
//   observer.observe(document.body, {
//     attributes: true
//   });

//     // Get all swatch inputs
//     const swatchInputs = document.querySelectorAll('.swatch input[type="radio"]');
//     // Add event listener to each swatch input
//     swatchInputs.forEach(input => {
//       input.addEventListener('change', function() {
//         // Get the value of the selected swatch input
//         const selectedValue = this.value;
//         // console.log({selectedValue});
//         // Find the parent form of the clicked swatch input
//         const parentForm = this.closest('form');
//         // Find the select element within the parent form
//         const selectElement = parentForm.querySelector('select[name="id"]');
//         // console.log({selectElement});
//         const options = selectElement.options;
//         for (let i = 0; i < options.length; i++) {
//           if (options[i].text === selectedValue) {
//             // Change the select element to match the selected swatch input
//             selectElement.selectedIndex = i;
//             const selectedPrice = options[i].getAttribute('data-price');
//             const qtyInCart = parseInt(options[i].getAttribute('data-cart-qty'), 10);
//             const lineItemInCart = parseInt(options[i].getAttribute('data-cart-line-index'), 10);
//             const variantIdItemInCart = parseInt(options[i].getAttribute('data-cart-item-option-variant-id'), 10);
//             // console.log({ selectedPrice });
//             // console.log({ qtyInCart });
//             // console.log({ variantIdItemInCart });
//             const price = parseFloat(selectedPrice.replace('$', ''));
//             const dollars = Math.floor(price);
//             const cents = Math.round((price - dollars) * 100);
//             const productWrap = parentForm.closest('.product-wrap');
//             if (parentForm) {
//               const purchaseDetails = parentForm.querySelector('.purchase-details');
//               const atcPrice = parentForm.querySelector('.in-atc-price');
//               atcPrice.textContent=selectedPrice;
//               const qtyWrapper = parentForm.querySelector('.purchase-details__quantity');
//               // console.log({purchaseDetails}, qtyInCart);
//               const inputElement = parentForm.querySelector('.quantity-input');
//               const purchaseDetailsQuantity = parentForm.querySelector('.purchase-details__quantity');
//               purchaseDetailsQuantity.setAttribute('data-cart-item-variant-id',variantIdItemInCart);
//               if (qtyInCart > 0) {
//                 purchaseDetails.classList.add('item-in-cart-purchase-details');
//                 qtyWrapper.classList.add('item-in-cart-show-qty');
//                 inputElement.value = qtyInCart;
//                 inputElement.setAttribute('data-line-id',lineItemInCart);
//                 purchaseDetailsQuantity.setAttribute('data-line-item',lineItemInCart);
//                 purchaseDetailsQuantity.setAttribute('data-line-item-key',lineItemInCart);

//               } else {
//                 inputElement.value = 1;
//                 purchaseDetails.classList.remove('item-in-cart-purchase-details');
//                 qtyWrapper.classList.remove('item-in-cart-show-qty');
//               }
//             }
//             if (productWrap) {
//               const dollarElement = productWrap.querySelector('.thumbnail-price-dollars');
//               const centsElement = productWrap.querySelector('.thumbnail-price-cents');
//               if (dollarElement) {
//                 dollarElement.textContent = dollars;
//               }
//               if (centsElement) {
//                 centsElement.textContent = cents < 10 ? '0' + cents : cents;
//               }
//             }
//             break;
//           }
//         }
//       });
//     });
  
// });

// document.querySelectorAll('[data-value-handle-link]').forEach(linkElement => {
//   linkElement.addEventListener('click', function () {
//     const linkValue = this.getAttribute('data-value-handle-link');
//     const targetInput = document.querySelector(`[data-value-handle-target="${linkValue}"]`);
//     const buttonGroup = this.closest('.image-variant-buttons');
//     if (buttonGroup) {
//       buttonGroup.querySelectorAll('.image-variant-button').forEach(button => {
//         button.classList.remove('image-variant-button-active');
//       });
//       this.classList.add('image-variant-button-active');
//     }
    
//     if (targetInput) {
//       targetInput.click();
//       // console.log(`Clicked on target input:`, targetInput);
//     } else {
//       // console.log(`No target input found for: ${linkValue}`);
//     }
//   });
// });
